import { Component, Input,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    OnInit,
    OnDestroy
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject, Observable } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { PeopleSurveyRequestFormService} from '../../../../../services/people-survey-request-form.service';
import { ApiJobsService } from 'src/app/jobs/services/api-jobs.service';
import { PeopleSurveyRequestHelper } from '../../people-survey-request.helper';
import * as locales from 'src/assets/locales/locales.json';

@Component({
    selector: 'app-people-survey-request-options-info',
    templateUrl: './options-info.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PeopleSurveyRequestOptionsInfoComponent implements OnInit, OnDestroy {
    @Input() surveyRequestFormGroup: UntypedFormGroup;
    @Input() sessionData: any;
    @Input() isFormSubmitted: boolean;

    private onDestroy$: Subject<null> = new Subject();
    public isOnlyIACSelected$: Observable<boolean>;
    public isOnlyIACSelected = false;
    public isOnlyMpoSelected$: Observable<boolean>;
    public isSatelliteSelected$: Observable<boolean>;
    public satellidJobList$: Observable<any>;
    public satelliteJobList;
    public variantOptions$: Observable<any[]>;
    public trackById: Function;
    public countryList: any[];
    public langList$: Observable<any[]>;
    public localeList: any;

    constructor(
        private peopleRequestFormService: PeopleSurveyRequestFormService,
        private apiJobs: ApiJobsService,
        private translateService: TranslateService,
        private changeDetectorRef: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.trackById = PeopleSurveyRequestHelper.trackById;

        this.isOnlyMpoSelected$ = this.peopleRequestFormService.isOnlyMpoSelected$.pipe(takeUntil(this.onDestroy$), distinctUntilChanged());
        this.isOnlyIACSelected$ = this.peopleRequestFormService.isOnlyIACSelected$.pipe(takeUntil(this.onDestroy$), distinctUntilChanged());
        this.isOnlyIACSelected$.subscribe((res) => {
            this.isOnlyIACSelected = res;
            this.changeDetectorRef.markForCheck();
        });

        this.isSatelliteSelected$ = this.peopleRequestFormService.isSatelliteSelected$.pipe(takeUntil(this.onDestroy$), distinctUntilChanged());
        this.variantOptions$ = this.peopleRequestFormService.variantOptions$.pipe(takeUntil(this.onDestroy$), distinctUntilChanged());

        this.satellidJobList$ = this.apiJobs.jobs([{'isSatellite': 1, 'fields': 'id,jobTitle'}]).pipe(takeUntil(this.onDestroy$), distinctUntilChanged());
        this.satellidJobList$.subscribe((jobs) => {
            this.satelliteJobList = jobs.data;
            this.changeDetectorRef.markForCheck();
        });

        this.countryList = this.sessionData.structure.countries[this.translateService.currentLang];
        this.langList$ = this.peopleRequestFormService.langList$.pipe(takeUntil(this.onDestroy$), distinctUntilChanged());
        this.setLocaleList();
    }

    get noLanguageSelected() {
        return (
            this.surveyRequestFormGroup.get('language').value === null ||
            this.surveyRequestFormGroup.get('language').value === 'none'
        );
    }

    setLocaleList() {
        const currentLanguage = this.translateService.currentLang;
        this.localeList = (locales as any).default[currentLanguage];
    }

    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
}
